import { render, staticRenderFns } from "./ReportFailed.vue?vue&type=template&id=6d759e9d&"
import script from "./ReportFailed.vue?vue&type=script&lang=js&"
export * from "./ReportFailed.vue?vue&type=script&lang=js&"
import style0 from "./ReportFailed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports